import { useQuery } from "react-query";
import { useLocation, Navigate } from "react-router-dom";
import { ApiParams } from "../api/@types/apiTypes";
import { indexLiaisonsStudents } from "../api/endpoints/liaisons/students";
import StudentModel from "../api/models/StudentModel";
import SplashScreen from "../views/SplashScreen";
function LiaisonDashboardContainer() {
  const location: any = useLocation();
  const { data: students, isLoading } = useQuery(
    "liaisonStudents",
    () => {
      const apiFilters: ApiParams = {};
      apiFilters["is_scheduled"] = true;
      return indexLiaisonsStudents({ filters: apiFilters });
    },
    {
      staleTime: 0,
      select: (response) => {
        if (response.isSuccess) {
          const data: StudentModel[] = StudentModel.fromApiResponse(
            response.data
          );
          return data;
        }
      },
    }
  );

  if (isLoading) return <SplashScreen />;
  if (!students?.length && location?.state?.from === "/login")
    return <Navigate to="/liaison/dashboard/candidates" />;

  return <Navigate to="/liaison/dashboard/readers" />;
}

export default LiaisonDashboardContainer;
